import styled from 'styled-components'

const TwoStepPaymentFormStepSubHeadlineUi = styled.div`
  font-size: 12px;
`

export default TwoStepPaymentFormStepSubHeadlineUi
